import { forEach } from 'lodash';
import Dropdown from 'shared/dropdown';

export default class DropdownNav {
  constructor(root) {
    this.root = root;
    this.lis = this.root.querySelectorAll('li.has-dropdown');

    if (this.lis.length === 0) {
      return { empty: true };
    }

    this.init()
  }

  init() {
    forEach(this.lis, (li) => {
      const trigger = li.parentNode.querySelector('li.has-dropdown > a');
      const level = li.querySelector('nav[data-nav-level="1"]');

      li.setAttribute('data-dropdown', '');
      trigger.setAttribute('data-dropdown-trigger', '');
      level.setAttribute('data-dropdown-content', '');
      level.classList.add('u-dropdown');

      li.dropdown = new Dropdown(li);
    });
  }

  destroy() {
    forEach(this.lis, (li) => {
      const trigger = li.parentNode.querySelector('li.has-dropdown > a')
      const level = li.querySelector('nav[data-nav-level="1"]');

      li.removeAttribute('data-dropdown');
      trigger.removeAttribute('data-dropdown-trigger');
      level.removeAttribute('data-dropdown-content');
      level.classList.remove('u-dropdown');

      li.dropdown.destroy();
    });
  }
}
